var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#b88b55",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.99975,228H139.72143a263.72805,263.72805,0,0,0,31.29688-30.375c26.81054-30.832,40.98144-63.207,40.98144-93.625a84,84,0,0,0-168,0c0,30.418,14.1709,62.793,40.98145,93.625A263.7281,263.7281,0,0,0,116.27807,228H55.99975a4,4,0,0,0,0,8h144a4,4,0,0,0,0-8ZM90.89624,192.23437C73.1521,171.79541,51.99975,139.89648,51.99975,104a76,76,0,0,1,152,0c0,35.89648-21.15234,67.79541-38.89648,88.23437a254.03965,254.03965,0,0,1-37.10352,34.80079A254.04027,254.04027,0,0,1,90.89624,192.23437ZM163.99975,104a36,36,0,1,0-36,36A36.04061,36.04061,0,0,0,163.99975,104Zm-64,0a28,28,0,1,1,28,28A28.03146,28.03146,0,0,1,99.99975,104Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.da0a41150f7b8064f470b7639e6c57da.svg";
export { ForwardRef as ReactComponent };